<template>
    <div class="st-card">
        <div class="st-card-header">
            <div class="st-card-icon">
                <i class="fal fa-envelope"></i>
            </div>
            <div>
                <h2 class="st-card-title">Configuration de l'en-tête mail et SMTP</h2>
                <p class="st-card-desc">{{ $t('companies.settings.sending_mails.title') }}</p>
            </div>
        </div>

        <div class="st-card-body">
            <!-- Sender name -->
            <div class="st-field">
                <label class="st-label" for="companyName">{{ $t('companies.settings.sending_mails.sender') }} *</label>
                <input id="companyName" v-model="company.settings_sender_name" required class="st-input" type="text" />
                <p v-if="isSettingsSend && nameMessage" class="st-error">{{ nameMessage }}</p>
            </div>

            <!-- Sender email -->
            <div class="st-field">
                <label class="st-label" for="companyEmail">{{ $t('companies.settings.sending_mails.sender_mail') }} *</label>
                <input id="companyEmail" v-model="company.settings_sender_mail" required class="st-input" type="email" />
                <p v-if="isSettingsSend && mailMessage" class="st-error">{{ mailMessage }}</p>
            </div>

            <!-- Advanced config -->
            <div class="st-section-title">
                <i class="fal fa-server"></i>
                {{ $t('companies.settings.sending_mails.advanced_config') }}
            </div>

            <div class="st-grid-2">
                <div class="st-field">
                    <label class="st-label" for="mailProtocol">{{ $t('companies.settings.sending_mails.protocol') }}</label>
                    <select id="mailProtocol" v-model="company.settings_mail_protocol" class="st-input">
                        <option value="smtp">SMTP</option>
                        <option value="pop">POP</option>
                        <option value="imap">IMAP</option>
                    </select>
                </div>
                <div class="st-field">
                    <label class="st-label" for="mailHost">{{ $t('companies.settings.sending_mails.host') }}</label>
                    <input id="mailHost" v-model="company.settings_mail_host" class="st-input" type="text" />
                </div>
                <div class="st-field">
                    <label class="st-label" for="mailPort">{{ $t('companies.settings.sending_mails.port') }}</label>
                    <input id="mailPort" v-model="company.settings_mail_port" class="st-input" type="number" />
                </div>
                <div class="st-field">
                    <label class="st-label" for="mailUsername">{{ $t('companies.settings.sending_mails.username') }}</label>
                    <input id="mailUsername" v-model="company.settings_mail_username" class="st-input" type="text" />
                </div>
                <div class="st-field">
                    <label class="st-label" for="mailPassword">{{ $t('companies.settings.sending_mails.password') }}</label>
                    <input id="mailPassword" v-model="company.settings_mail_password" class="st-input" type="password" />
                    <p v-if="isSettingsSend && passwordmessage" class="st-error">{{ passwordmessage }}</p>
                </div>
                <div class="st-field">
                    <label class="st-label" for="mailPasswordConfirmation">{{ $t('companies.settings.sending_mails.password_confirmation') }}</label>
                    <input id="mailPasswordConfirmation" v-model="company.settings_mail_password_confirmation" class="st-input" type="password" />
                </div>
            </div>

            <!-- HTML template -->
            <div class="st-field">
                <label class="st-label">Mise en page HTML</label>
                <div class="mail-template-wrap">
                    <div class="mail-template-editor">
                        <div class="mail-template-tabs">
                            <button
                                class="mail-template-tab"
                                :class="{ 'is-active': templateTab === 'code' }"
                                @click="templateTab = 'code'"
                            >
                                <i class="fal fa-code"></i> Code
                            </button>
                            <button
                                class="mail-template-tab"
                                :class="{ 'is-active': templateTab === 'preview' }"
                                @click="templateTab = 'preview'"
                            >
                                <i class="fal fa-eye"></i> Aperçu
                            </button>
                        </div>
                        <textarea
                            v-show="templateTab === 'code'"
                            v-model="headerMail.settings_mail_template"
                            class="mail-template-textarea"
                            rows="12"
                        ></textarea>
                        <div
                            v-show="templateTab === 'preview'"
                            class="mail-template-preview"
                            v-html="headerMail.settings_mail_template"
                        ></div>
                    </div>
                </div>
            </div>

            <!-- Pictures -->
            <div class="st-field">
                <label class="st-label">Autres images</label>
                <BmvFileUpload
                    :multiple="true"
                    :max="10"
                    :accepted-extensions="['png', 'jpg', 'jpeg']"
                    :value="picturesAttribute.value"
                    @input="addCompanyPictures"
                />
            </div>
        </div>

        <div class="st-card-footer">
            <button class="st-btn st-btn--primary" @click.prevent="save">
                <i class="fal fa-save" style="color: #fff !important;"></i>
                {{ $t('companies.settings.change_settings') }}
            </button>
        </div>
    </div>
</template>

<script>
import BmvFileUpload from '@/components/UI/BmvFileUpload'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'SettingsMail',
    components: { BmvFileUpload },
    data() {
        return {
            isSettingsSend: false,
            templateTab: 'code',
            nameMessage: '',
            passwordmessage: '',
            mailMessage: '',
            mailregExp:
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            picturesAttribute: {
                config: {
                    'accepted-ext': ['png', 'jpg', 'jpeg', 'PNG', 'JPG', 'JPEG'],
                    max: 10,
                    min: 0,
                    type: 'pictures',
                    value: null
                }
            }
        }
    },
    computed: {
        ...mapState('company', {
            company: (state) => state.companySettings,
            headerMail: (state) => state.companyHeaderMail
        })
    },
    methods: {
        ...mapActions('company', ['sendCompanySettings', 'sendCompanyHeaderMail']),
        addCompanyPictures(value) {
            this.headerMail.settings_pictures = value
        },
        save() {
            this.isSettingsSend = true
            this.confirmName(this.company.settings_sender_name)
            this.confirmMail(this.company.settings_sender_mail)
            this.confirmPassword(
                this.company.settings_mail_password,
                this.company.settings_mail_password_confirmation
            )

            if (!this.nameMessage && !this.mailMessage && !this.passwordmessage) {
                this.sendCompanySettings()
                    .then(() => {
                        return this.sendCompanyHeaderMail()
                    })
                    .then(() => {
                        this.$store.dispatch('toast', {
                            type: 'success',
                            title: this.$t('companies.settings.settings_modified')
                        })
                    })
                    .catch((error) => {
                        this.$store.dispatch('dispatchError', error)
                    })
            }
        },
        confirmPassword(password, passwordConfirmation) {
            this.passwordmessage = password !== passwordConfirmation
                ? this.$t('error.validation.password_mismatch')
                : ''
        },
        confirmMail(email) {
            if (!email) {
                this.mailMessage = this.$t('error.validation.required')
            } else if (!this.mailregExp.test(email)) {
                this.mailMessage = this.$t('error.validation.mail_valid')
            } else {
                this.mailMessage = ''
            }
        },
        confirmName(name) {
            this.nameMessage = !name ? this.$t('error.validation.required') : ''
        },
        initPicturesValue() {
            this.picturesAttribute.value = this.headerMail.settings_pictures || null
        }
    },
    watch: {
        'headerMail.settings_pictures': {
            immediate: true,
            handler() {
                this.initPicturesValue()
            }
        }
    }
}
</script>

<style scoped>
.mail-template-wrap {
    border: 1.5px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
}

.mail-template-tabs {
    display: flex;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}

.mail-template-tab {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border: none;
    background: none;
    font-size: 0.78rem;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: all 0.15s;
}

.mail-template-tab:hover {
    color: #0891B2;
}

.mail-template-tab.is-active {
    color: #0891B2;
    border-bottom-color: #0891B2;
    background: #fff;
}

.mail-template-tab i {
    font-size: 0.82rem;
}

.mail-template-textarea {
    width: 100%;
    box-sizing: border-box;
    border: none;
    padding: 16px;
    font-family: 'Courier New', monospace;
    font-size: 0.82rem;
    color: #334155;
    background: #fff;
    outline: none;
    resize: vertical;
    min-height: 200px;
}

.mail-template-preview {
    padding: 16px;
    min-height: 200px;
    background: #fff;
    font-size: 0.88rem;
    color: #334155;
    line-height: 1.6;
    overflow: auto;
}
</style>
